import React, { useEffect, useState } from "react";

interface LoadingScreenProps {
  message: string;
  className?: string;
  id?: string;
}

function isDarkMode(): boolean {
  const mode = localStorage.getItem("MODE");
  if (!mode) return false;

  // If it looks like JSON (old format), parse it. Otherwise use directly (new format)
  const actualMode = /^".*"$/.test(mode) ? JSON.parse(mode) : mode;

  // Maintain backward compatibility: check if the mode contains "dark" (for edge cases)
  return actualMode.includes("dark");
}

async function getLogo(): Promise<string> {
  const logoPath = isDarkMode() ? "assets/sans-ondemand-dark.png" : "assets/sans-ondemand.png";

  try {
    const response = await fetch(logoPath);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Failed to load logo:", error);
    // Fallback to original path if Base64 conversion fails
    return logoPath;
  }
}

function getTextColor(): string {
  return isDarkMode() ? "#BBB" : "#666";
}

function getBackgroundColor(): string {
  return isDarkMode() ? "#16181F" : "#FFF";
}

export function LoadingScreen({
  message,
  className = "App",
  id = "App",
}: Readonly<LoadingScreenProps>): React.ReactElement {
  const [logoSrc, setLogoSrc] = useState<string>("");

  useEffect(() => {
    getLogo().then(setLogoSrc);
  }, []);

  return (
    <div
      className={className}
      id={id}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: getBackgroundColor(),
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div>{logoSrc && <img src={logoSrc} alt="SANS OnDemand logo" style={{ width: "160px" }} />}</div>
        <div
          style={{
            fontSize: "0.85rem",
            color: getTextColor(),
            width: "63px",
            textAlign: "left",
            margin: "14px auto 0 auto",
          }}
        >
          {logoSrc ? message : ""}
        </div>
      </div>
    </div>
  );
}
